import { render } from "./profile-picture-modal.vue?vue&type=template&id=49d0c064&ts=true"
import script from "./profile-picture-modal.vue?vue&type=script&lang=ts"
export * from "./profile-picture-modal.vue?vue&type=script&lang=ts"

import "./profile-picture-modal.vue?vue&type=style&index=0&id=49d0c064&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__